import { render, staticRenderFns } from "./FulfillmentIndex.vue?vue&type=template&id=4b27846a&scoped=true&"
import script from "./FulfillmentIndex.vue?vue&type=script&lang=js&"
export * from "./FulfillmentIndex.vue?vue&type=script&lang=js&"
import style0 from "./FulfillmentIndex.vue?vue&type=style&index=0&id=4b27846a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b27846a",
  null
  
)

export default component.exports